export default "__VITE_ASSET__Br0WS14X__"